export default "__VITE_ASSET__DEBz0JHx__"